import { Field } from '../domain/Field';
import { Widget } from '../widget/widget';
import { WidgetFactory } from '../widget/WidgetFactory';
import { TypeInfo } from './TypeInfo';

export class ColorRGB extends TypeInfo {
	constructor() {
		super();
	}

	canAcceptValue(value: any): boolean {
		// TODO: test if actually color value
		return typeof(value) == 'string';
	}

	isFreeInput(): boolean {
		return true;
	}

	getDefaultValue(): any {
		return '#000000';
	}

	toString(): string {
		return 'RGB';
	}

	createWidget(field: Field): Widget {
		return WidgetFactory.createColor(field);
	}
}

export class ColorRGBA extends TypeInfo {
	constructor() {
		super();
	}

	canAcceptValue(value: any): boolean {
		// TODO: test if actually color value
		return typeof(value) == 'string';
	}

	isFreeInput(): boolean {
		return true;
	}

	getDefaultValue(): any {
		return 'rgba(0, 0, 0, 1.0)';
	}

	toString(): string {
		return 'RGBA';
	}

	createWidget(field: Field): Widget {
		return WidgetFactory.createColor(field);
	}
}
